export enum FormType {
	Login = 'login',
	Register = 'register',
	Forgot = 'forgot',
	EmailVerification = 'emailVerify',
}
